import { Route, Switch } from 'react-router-dom';
import { Redirect, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'draft-js/dist/Draft.css';

import CommonContainer from "../CommonContainer";
import Header from "../CommonComponents/Header";
import General from "./general";
import AppEmail from "./app"

const UserSettings = () => {
    const history = useHistory()

    const onChangeTab = (currentTab) => {
        if (currentTab === 'general') {
            history.push("/user-settings/general")
        } else if (currentTab === 'app') {
            history.push("/user-settings/app")
        }
    }

    return (
        <CommonContainer>
            <Header header='Settings' />
            <div className="d-flex column-gap-5  mt-5">
                <h4
                    className="fw-bold"
                    onClick={() => { onChangeTab('general') }}
                >
                    General
                </h4>
                <h4
                    onClick={() => { onChangeTab('app') }}
                    className="fw-bold"
                >
                    App Settings
                </h4>
            </div>
            <div>
                <Switch>
                    <Route path="/user-settings/general" component={General} />
                    <Route path="/user-settings/app" component={AppEmail} />
                    <Redirect exact from="/user-settings" to="/user-settings/general" />
                </Switch>
            </div>

        </CommonContainer>

    )
}
export default UserSettings;